import React from 'react';
import factory from 'components/Icons/factory';

// Icons are built as 128x128 originals
export const Print = factory(
  'Print',
  <path d="M99 53H29V13h70v40zm0 61.8H29V82h70v32.8zM118.5 53H104V8H24v45H9.5C4.2 53 0 56.9 0 62.1v31c0 5.2 4.2 9.8 9.5 9.8H24V120h80v-17.1h14.5c5.2 0 9.5-4.6 9.5-9.8v-31c0-5.2-4.2-9.1-9.5-9.1z" />
);

export default Print;
